import API from '@/api'

export const moduleName = 'statistical'

export const actionTypes = {
  ACTION_LOAD_METRICS: 'ACTION_LOAD_METRICS',
  ACTION_CLEAN_METRICS: 'ACTION_CLEAN_METRICS',
  ACTION_LOAD_CHARTS: 'ACTION_LOAD_CHARTS',
  ACTION_CLEAN_CHARTS: 'ACTION_CLEAN_CHARTS',
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_JOIN_TO_DASHBOARD: 'ACTION_JOIN_TO_DASHBOARD',
  ACTION_LOAD_APP_ROUTES: 'ACTION_LOAD_APP_ROUTES',
  ACTION_LOAD_SEO_LIST: 'ACTION_LOAD_SEO_LIST',
  ACTION_ADD_SEO_PAGE: 'ACTION_ADD_SEO_PAGE',
  ACTION_PAGE_REOLAD: 'ACTION_PAGE_REOLAD',
  ACTION_EDIT_SEO: 'ACTION_EDIT_SEO'
}

export const getterTypes = {
  GET_METRICS: 'GET_METRICS',
  GET_CHARTS: 'GET_CHARTS',
  GET_APP_ROUTES: 'GET_APP_ROUTES',
  GETTER_PAGE_RELOAD: 'GETTER_PAGE_RELOAD',
  GETTER_SEO_LIST: 'GETTER_SEO_LIST',
  GETTER_PAGE_SEO_DATA_COUNT: 'GETTER_PAGE_SEO_DATA_COUNT'
}

export const mutationTypes = {
  SET_METRICS: 'SET_METRICS',
  SET_CHARTS: 'SET_CHARTS',
  UPDATE_METRIC: 'UPDATE_METRIC',
  SET_APP_ROUTES: 'SET_APP_ROUTES',
  MUTATION_SET_PAGE_RELOAD: 'MUTATION_SET_PAGE_RELOAD',
  MUTATION_SET_SEO_LIST: 'MUTATION_SET_SEO_LIST',
  MUTATION_SET_PAGE_SEO_COUNT: 'MUTATION_SET_PAGE_SEO_COUNT',

}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    charts: {},
    metrics: [],
    appRoutes: [],
    isPageReload: false,
    seoLists: [],
    pageSeoCount: 0
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit }) {
      const onUpdateMetric = ({ value }) => {
        commit(mutationTypes.UPDATE_METRIC, value)
      }

      Object.keys(API.statistical.wsEvents).forEach((eventName) => {
        API.statistical.wsListeners[eventName](onUpdateMetric)
      })
    },

    [actionTypes.ACTION_JOIN_TO_DASHBOARD] () {
      API.statistical.wsActions.ACTION_JOIN_TO_DASHBOARD()
    },

    async [actionTypes.ACTION_LOAD_METRICS] ({ commit }) {
      commit(mutationTypes.SET_METRICS, [])
      const { data: metrics } = await API.statistical.loadMetrics()
      commit(mutationTypes.SET_METRICS, metrics)
    },

    async [actionTypes.ACTION_LOAD_APP_ROUTES] ({ commit }) {
      commit(mutationTypes.SET_APP_ROUTES, [])
      const {data} = await API.statistical.loadAppRoutes()
      commit(mutationTypes.SET_APP_ROUTES, data)
    },

    [actionTypes.ACTION_CLEAN_METRICS] ({ commit }) {
      commit(mutationTypes.SET_METRICS, {})
    },

    async [actionTypes.ACTION_LOAD_CHARTS] ({ commit }, payload) {
      const { data: charts } = await API.statistical.loadChartsData(payload)
      commit(mutationTypes.SET_CHARTS, charts)
    },

    [actionTypes.ACTION_CLEAN_CHARTS] ({ commit }) {
      commit(mutationTypes.SET_CHARTS, {})
    },
    async [actionTypes.ACTION_LOAD_SEO_LIST]({ commit }, payload) {
      const { data: {seos, count} } = await API.statistical.getSeoBypages(payload);
      commit(mutationTypes.MUTATION_SET_PAGE_SEO_COUNT, count);
      commit(mutationTypes.MUTATION_SET_SEO_LIST, seos);
    },
    async [actionTypes.ACTION_ADD_SEO_PAGE]({ commit }, payload) {
      try{
        await API.statistical.addSeo(payload);
        commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true );
      }catch(err){
        console.log("err",err)
      }

    },

    async [actionTypes.ACTION_EDIT_SEO]({ commit }, payload) {
      await API.statistical.editSeo(payload);

      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true );
    },
    [actionTypes.ACTION_PAGE_REOLAD]({ commit }, payload) {
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, payload );
      return true
    },
  },

  mutations: {
    [mutationTypes.MUTATION_SET_PAGE_SEO_COUNT] (state, count) {
      state.pageSeoCount = count
    },
    [mutationTypes.SET_APP_ROUTES] (state, value) {
      state.appRoutes = value
    },
    [mutationTypes.MUTATION_SET_SEO_LIST] (state, value) {
      state.seoLists = value
    },
    [mutationTypes.SET_METRICS] (state, value) {
      state.metrics = value
    },
    [mutationTypes.SET_CHARTS] (state, value) {
      state.charts = value
    },
    [mutationTypes.UPDATE_METRIC] (state, [type, value]) {
      if (!state.metrics?.findIndex) return
      const metricIndex = state.metrics.findIndex(m => m.title === type)
      if (metricIndex >= 0) {
        const chartData = state.metrics[metricIndex].chartData

        if (chartData.length > 0 && chartData[chartData.length - 1] < value) {
          chartData.splice(chartData.length - 1, 1, value)
        }

        const updatedMetric = {
          ...state.metrics[metricIndex],
          value
        }

        state.metrics.splice(metricIndex, 1, updatedMetric)
      }
    },
    [mutationTypes.MUTATION_SET_PAGE_RELOAD](state, pageReload) {
      state.isPageReload = pageReload
    },
  },

  getters: {
    [getterTypes.GET_METRICS]: (state) => state.metrics,
    [getterTypes.GET_CHARTS]: (state) => state.charts,
    [getterTypes.GET_APP_ROUTES]: (state) => state.appRoutes,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,
    [getterTypes.GETTER_SEO_LIST]: (state) => state.seoLists,
    [getterTypes.GETTER_PAGE_SEO_DATA_COUNT]: (state) => state.pageSeoCount,

  }
}
